import { useTranslation } from 'react-i18next';
import { SUPPORTED_EVM_CHAINS } from '../../lib/chainList';
import { selectFieldClass } from './fieldClasses';

type Props = {
  id: string;
  value: string;
  onChange: (chain: string) => void;
  /** Override shell classes (keep height/spacing consistent when needed). */
  className?: string;
};

export function ChainSelect({ id, value, onChange, className }: Props) {
  const { t } = useTranslation();
  return (
    <select id={id} className={className ?? selectFieldClass} value={value} onChange={(e) => onChange(e.target.value)}>
      {SUPPORTED_EVM_CHAINS.map((ch) => (
        <option key={ch} value={ch}>
          {t(`wallet.chain.${ch}`)}
        </option>
      ))}
    </select>
  );
}
